import isEmpty from "lodash/isEmpty";
import { useEffect } from "react";
import { SERVICES_PATH } from "../../common/env";
import { useLocationSlug } from "../../hooks/useLocationSlug";
import { useNextURL } from "../../hooks/useNextURL";
import { getNextUrlFromParams } from "../../utils/getNextUrlFromParams";

interface StoreNextURLProps {
  readonly children?: React.ReactNode;
  readonly nextUrl?: string | null;
}

export function StoreServiceIdFromLocationSlugIntoNextUrl({
  children,
  nextUrl = getNextUrlFromParams(),
}: StoreNextURLProps): JSX.Element {
  const { slug } = useLocationSlug();
  const { set } = useNextURL();

  useEffect(
    function storeNextUrlIfExistsOnLoad() {
      if (!isEmpty(slug)) {
        const nextUrl = `${SERVICES_PATH}/${slug}`;

        set(nextUrl);
      }
    },
    [nextUrl, slug]
  );

  return <>{children}</>;
}
